
import { defineComponent } from 'vue';
import { debounce } from 'lodash';

interface Item {
    id: any;
    [key: string]: any;
}

export default defineComponent({
    name: 'SearchComponent',
    props: {
        results: { type: Array as() => Item[], default: () => [] },
        placeholder: { type: String, default: 'providerManagement.placeholder.companysearchterm' },
        displayField: { type: String, default: 'name' },
        emptyMessage: { type: String, default: 'global.emptyList' }
    },
    data() {
        return {
            // User input search query
            searchQuery: '' as string,
            // Debounced search function to limit the frequency of emitting the search event
            debouncedSearch: (() => {}) as() => void
        };
    },
    created() {
        this.debouncedSearch = debounce(() => {
            this.$emit('search', this.searchQuery);
        }, 300);
    },
    methods: {
        // Called on input event to trigger the debounced search
        onInput() {
            this.debouncedSearch();
        },
        // Emit the selected item id when an item is clicked
        selectItem(item: Item) {
            this.$emit('item-selected', item.id);
        },
        // Clear the search input field
        clearSearch() {
            this.searchQuery = '';
        }
    }
});
